import { render } from "./SummaryCampaign.vue?vue&type=template&id=155a4112&scoped=true"
import script from "./SummaryCampaign.vue?vue&type=script&lang=js"
export * from "./SummaryCampaign.vue?vue&type=script&lang=js"

import "./SummaryCampaign.vue?vue&type=style&index=0&id=155a4112&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155a4112"]])

export default __exports__